export default __webpack_public_path__ + "static/media/terms-of-service-consent-en-3.650c7ee6.jpg";